import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { IoIosArrowDown, IoIosArrowForward } from "react-icons/io";
import { mergeClass } from "@/utils/helper";

const MenuItem = ({
  item,
  isOpen,
  expandedMenu,
  toggleSubMenu,
  index,
  styles,
  parentItem = null,
}) => {
  const [submenuExpanded, setSubmenuExpanded] = useState(null);
  const [hasExpandedInitially, setHasExpandedInitially] = useState(false);
  const location = useLocation();

  const handleSubMenuToggle = (subIndex) => {
    setSubmenuExpanded(submenuExpanded === subIndex ? null : subIndex);
  };

  // Determine if this menu item or its parent is active
  const isActive = location.pathname === item.pagePath;
  const isActiveParent =
    location.pathname.indexOf(
      (parentItem?.prefixPath ?? "") + item.prefixPath
    ) === 0;

  // Auto-expand the parent menu if it's the active route, only on the first render
  useEffect(() => {
    if (
      isActiveParent &&
      item?.submenu &&
      expandedMenu !== index &&
      !hasExpandedInitially
    ) {
      toggleSubMenu(index);
      setHasExpandedInitially(true); // Prevents auto-expansion after the first render
    }
  }, [
    isActiveParent,
    index,
    item?.submenu,
    toggleSubMenu,
    expandedMenu,
    hasExpandedInitially,
  ]);

  return (
    <li
      className={`${styles.sidebarItem} ${
        isActive ? styles.activeSidebarItem : ""
      }`}
    >
      <Link
        to={item.pagePath}
        className={`${styles.sidebarLink} ${
          isActive ? styles.activeSidebarLink : ""
        }`}
        onClick={() => (item?.submenu ? toggleSubMenu(index) : null)}
      >
        <span className={styles.sidebarIcon}>
          {item?.icon ? (
            item.icon
          ) : (
            <div className={styles.svgContainer}>
              <img src={item?.svg} className={styles.svg} alt="description" />
            </div>
          )}
        </span>
        {isOpen && (
          <span className={mergeClass("fw-300 ", styles.sidebarLabel)}>
            {item.name}
          </span>
        )}
        {item?.submenu && (
          <span className={styles.arrow}>
            {expandedMenu === index ? (
              <IoIosArrowDown />
            ) : (
              <IoIosArrowForward />
            )}
          </span>
        )}
      </Link>

      {expandedMenu === index && isOpen && item.submenu && (
        <ul className={styles.submenuList}>
          {item.submenu.map((subItem, subIndex) => (
            <MenuItem
              key={subIndex}
              item={subItem}
              isOpen={isOpen}
              expandedMenu={submenuExpanded}
              toggleSubMenu={handleSubMenuToggle}
              index={subIndex}
              styles={styles}
              parentItem={item}
            />
          ))}
        </ul>
      )}
    </li>
  );
};

export default MenuItem;
